import useMapEnum from "src/functions/mappers/use-map-enum";
import { Title_Enum } from "src/types/enums";

const titleOptions = useMapEnum(Object.values(Title_Enum))

export default titleOptions;
